import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: '[selectOnClick]'
})
export class SelectOnClickDirective {
    constructor(private el: ElementRef<HTMLInputElement>) {}

    @HostListener('click')
    onClick() {
        const input = this.el.nativeElement;
        input.select();
    }
}